@if (solrDataOption) {
  <rl-single-value-input [solrDataOption]="solrDataOption" [values]="[startValue]"
    (onChange)="setStart($event)">
  </rl-single-value-input>
}
<span class="mx-2"> and </span>
@if (solrDataOption) {
  <rl-single-value-input [solrDataOption]="solrDataOption" [values]="[endValue]"
    (onChange)="setEnd($event)">
  </rl-single-value-input>
}